module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/binding_sample/image06-3480208f58f6b2dedf03ba9fc4d9e4d5.png";